import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleNumber } from "../../../common/method/displayData";
import { actionTypes } from "./../../../redux/payments/select_payment_requests_limits";

let useStyles = makeStyles((theme) => ({
  modal: {
    width: "100%",
  },
  cardDate: {},
}));

export default function Index() {
  let classes = useStyles();
  let dispatch = useDispatch();

  const [state, setState] = useState([]);
  const [indexBankAccounts, setIndexBankAccounts] = useState(0);
  const [IndexDate, setIndexDate] = useState(0);

  let reducer = useSelector(
    (state) => state.selectPaymentRequestsLimitsReducer
  );

  useEffect(() => {
    if (reducer?.data?.length !== 0) {
      setState(reducer?.data);
    }
  }, [reducer?.data]);

  useEffect(() => {
    dispatch({ type: actionTypes.selectPaymentRequestsLimitsAsync });
  }, []);

  const handleChange = (event) => {
    setIndexDate(event.target.value);
    setIndexBankAccounts(event.target.value);
  };

  return (
    <div className={classes["modal"]}>
      <div>
        <h1>تقاضای وجه</h1>
        <hr className="mt-3 mb-3" />
      </div>
      <div className={"flex justify-between align-center"}>
        <div className="w-[50%]">
          <div className="mb-1 flex items-center justify-between">
            <p className="text-[blue]">تاریخ پرداخت</p>
            <p className="text-[blue]">حداکثر مبلغ برداشت</p>
          </div>
          <div>
            <FormControl className="w-[100%]">
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                className="w-[100%]"
                value={IndexDate}
                onChange={handleChange}
              >
                {state?.map((item, index) => {
                  return (
                    <div
                      className={`${classes["cardDate"]} flex items-center justify-between w-[100%]`}
                      key={index}
                    >
                      <div className="flex items-center justify-center">
                        <FormControlLabel value={index} control={<Radio />} />
                        <p className="p-0 m-0 ">{item?.date}</p>
                      </div>
                      <div>{handleNumber(item?.paymentRequestLimit)}</div>
                    </div>
                  );
                })}
              </RadioGroup>
            </FormControl>
          </div>

          <div className="mt-2">
            <TextField
              id="standard-select-currency"
              label={"مبلغ(ریال)"}
              // value={value}
              // onChange={event => setValue(event.target.value)}
              helperText=""
              size="medium"
              fullWidth
              variant="outlined"
              margin="dense"
              // onKeyDown={event => (event.keyCode === 13 ? handleSubmit() : "")}
            />
          </div>
          <div>
            <div className="mt-2">
              <p className="text-[blue]">شماره حساب مقصد</p>
            </div>
            <div>
              {state[indexBankAccounts] && (
                <>
                  {state[indexBankAccounts].bankAccounts?.map((item, index) => {
                    return (
                      <div
                        className="flex items-center justify-start mt-2"
                        key={index}
                      >
                        <div>
                          <FormControlLabel
                            // value={item.Date.split("T")[0]}
                            control={<Radio />}
                          />
                        </div>
                        <div>
                          <p className="mt-0">
                            {`${item?.bankName} ( ${item?.accountNumber} )`}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
          <div>
            <div className="mt-5">
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ width: 150, margin: 2 }}
                className="m-4 text-white"
              >
                ثبت درخواست
              </Button>
              <Button
                variant="contained"
                style={{ backgroundColor: "red", width: 150, margin: 2 }}
                size="large"
                // onClick={handleEnterLogin}
                // onClick={() => setOpen(true)}
                className="m-4 text-white"
              >
                لغو
              </Button>
            </div>
          </div>
        </div>

        <div className="border p-5">
          <p className="mb-2 text-[red]">قابل توجه مشتریان محترم</p>
          <p className="mb-2">در موارد زیر درخواست وجه پرداخت نخواهد شد</p>
          <p className="mb-2">نام صاحب حساب معرفی شده به نام شخص دیگری باشد</p>
          <p className="mb-2">حساب مشترک باشد</p>
          <p className="mb-2">حساب مسدود یا راکد باشد</p>
          <p className="mb-2">شماره حساب و شماره شبا دارای مغایرت باشند</p>
        </div>
      </div>
    </div>
  );
}
